<h1 mat-dialog-title>Modify Pre Filter</h1>
<div mat-dialog-content style="height: 700px">
  <form class="standard-form">
    <mat-form-field>
      <mat-label>Pre Filter Name</mat-label>
      <input matInput name="result.preFilter.name" [(ngModel)]="result.preFilter.name" />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Subscription</mat-label>
      <mat-select [(value)]="selectedSubscriptionId">
        <mat-option *ngFor="let subHeader of data.subscriptions" [value]="subHeader.subscriptionId">
          {{ subHeader.subscriptionName }} - {{ subHeader.organizationName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <ng-container>
        <button mat-raised-button class="piButton" (click)="editFilter()">Edit Filter</button>
    </ng-container>
    <ng-container>
      <input #fileInput type="file" id="inputFile" (change)="handleFileInput($event.target.files)" style="display: none" />
      <button mat-raised-button class="piButton" (click)="fileInput.click()">Upload Filter Template</button>
    </ng-container>
    <ng-container *ngIf="errorMessages && errorMessages.length > 0">
      <div *ngFor="let errorMessage of errorMessages">
        <mat-error>{{ errorMessage }}</mat-error>
      </div>
    </ng-container>
    <ng-container *ngIf="statusMessage">
      <b>{{ statusMessage }}</b>
    </ng-container>
  </form>
  <app-share-editor *ngIf="result.preFilter.owner" [allowReadOnly]="true" [allowModify]="true" [(ngModel)]="shareState" [avaialbleSubscriptions]="data.subscriptions"></app-share-editor>
</div>
<div mat-dialog-actions>
  <button mat-raised-button class="piButton" (click)="onSavePreFilter()">Save Pre Filter</button>
  <button mat-raised-button class="piButton" (click)="onCancelClick()">Cancel</button>
</div>
